export default {
  mapData: []
};
